"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Video Provider Configuration Information Service
 * Video provider configuration REST API for Frumos.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrmType = void 0;
/**
 * DRM type used for protecting the AV stream.
 * @export
 * @enum {string}
 */
exports.DrmType = {
    Clear: 'clear',
    FairPlay: 'fairPlay',
    PlayReady: 'playReady',
    Verimatrix: 'verimatrix',
    Widevine: 'widevine',
    Unknown: 'unknown'
};
